import { useBreakpointV2 } from "@tm/ui-widgets";
import {
  FlexComp,
  FormattedText,
  H3SmallTag,
  ImageComponent,
  ParaTag,
  SpanTag,
  TextNodeType,
} from "@tm/ui-widgets/components";
import { FeatList, SafenSecureTravCrdStyle } from "./SafenSecureTrav.style";

interface SafenSecureTravCrdProps {
  title?: TextNodeType;
  featList?: TextNodeType[];
  poweredBy?: string[];
  cardImg?: string;
  cardQuantity?: number;
}

const SafenSecureTravCrd = ({
  title,
  featList,
  cardImg,
  poweredBy,
  cardQuantity,
}: SafenSecureTravCrdProps) => {
  const device = useBreakpointV2();
  return (
    <SafenSecureTravCrdStyle>
      {device == "lg" ? (
        <H3SmallTag>{title && <FormattedText value={title} />}</H3SmallTag>
      ) : (
        <ParaTag
          fontWeight="black"
          fontSize="large"
          margin={device == "sm" ? "" : "0 0 12px"}
        >
          {title && <FormattedText value={title} />}
        </ParaTag>
      )}
      <FeatList cardQuantity={cardQuantity}>
        {featList &&
          featList?.map((item: TextNodeType, index: number) => {
            return (
              <li key={index}>
                <FormattedText value={item} />
              </li>
            );
          })}
      </FeatList>
      {poweredBy && (
        <FlexComp margin="auto 0 0" gap="20px" alignItems="Center">
          <SpanTag fontSize="xs">Powered By</SpanTag>
          {poweredBy &&
            poweredBy.map((item, index) => {
              return (
                <ImageComponent
                  key={index}
                  src={item}
                  height={"32px"}
                  width={"auto"}
                />
              );
            })}
        </FlexComp>
      )}
      {cardImg && (
        <ImageComponent
          width={device == "lg" ? "92px" : "54px"}
          height={device == "lg" ? "102px" : "60px"}
          src={cardImg}
        />
      )}
    </SafenSecureTravCrdStyle>
  );
};

export default SafenSecureTravCrd;
